import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root'
})
export class MasterClientePerfilAcessoService {

  constructor(private http: HttpClient) { }

  getProfileSearch(name) {
    return this.http.get<any>(`${BASE_PATH}/bff/master/clients/profiles?name=${name}`).toPromise();
  }

  /** Recupera lista de perfis para determinado cliente(s) */
  getProfiles() {
    return this.http.get<any>(`${BASE_PATH}/bff/master/edit-user/access-profiles/list`).toPromise();
  }

}